<template>
  <div>
    <!-- 日历票授权弹框开始 -->

    <el-dialog :close-on-click-modal="false"
      title="期票授权"
      :visible.sync="dataAuthorDialogVisible"
      :before-close="dataAuthorHandleClose"
      width="60%"
      center
    >
      <el-divider></el-divider>
      <!--  -->
      <div class="contentQp">

        <div class="qpLeft">
          <div class="titleSear">
            <el-input placeholder="请输入产品名称或产品ID" v-model="ProductName" ></el-input>
            <el-button @click="chaxun">查询</el-button>
          </div>
          <div style="display:flex;margin-top:2rem;">
            <div style="margin-left:3rem;">产品ID</div>
            <div style="margin-left:1.8rem;">产品名称</div>
          </div>
          <div v-for="(item,index) in notEmpow" :key='index' class="empow">
            <el-checkbox v-model="item.checked"  @change="ChangeforceUpdate"></el-checkbox>
            <span style="margin-left:2rem;">{{item.ProductID}}</span>
            <span style="margin-left:2rem;">{{ item.ProductName }}</span>
          </div>
        </div>
        <div class="qpCenter">
          <el-form ref="form" :model="form" label-width="80px" :label-position="labelPosition">
            <el-form-item label="代理价" prop="AgentPrice">
              <el-input 
                :value="form.AgentPrice"
                @input="handleAgentPriceInput"
                placeholder="请输入代理价"
              ></el-input>
            </el-form-item>
            <el-form-item label="每日代理数量" prop="DayNumber">
              <el-input 
                :value="form.DayNumber"
                @input="handleDayNumberInput"
                placeholder="请输入每日代理数量"
              ></el-input>
            </el-form-item>
            <el-form-item label="总代理数量" prop="AllNumber">
              <el-input 
                :value="form.AllNumber"
                @input="handleAllNumberInput"
                placeholder="请输入总代理数量"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="qpCenterBtn">
            <span>产品默认数据</span>
            <div>
              <button @click="select('form')">选择</button>
              <button @click="select1()">全部选择</button>
            </div>
            <div>
              <button @click="cancel">取消</button>
              <button @click="cancel('1')">全部取消</button>
            </div>
          </div>
        </div>
        <div class="qpRight"  v-loading="loadings"> 
          <div class="titleSear">
            <el-input placeholder="请输入产品名称或产品ID" v-model="ProductNamemper" ></el-input>
            <el-button @click="chaxunempower">查询</el-button>
          </div>
          <div style="display:flex;margin-top:2rem;">
            <div style="margin-left:3rem;">产品ID</div>
            <div style="margin-left:1.8rem;">产品名称</div>
          </div>
          <div v-for="(item,index) in empower" :key="index" class="empow" >
            <el-checkbox v-model="item.checked"   @change="ChangeforceUpdate"></el-checkbox>
            <span  style="margin-left:2rem;">{{item.ProductID}}</span>
            <span style="margin-left:2.4rem; color:#246deb;" @click="addProFn(item.ProductID)">{{ item.ProductName }}</span>
            <span>--代理价：{{ item.AgentPrice }}</span>
            <span>--每日数量：{{ item.DayNumber }}</span>
            <span>--总数量：{{ item.AllNumber }}</span>
          </div>
          <div>
            <span>注:</span>
            <span>数量为0的话就是不限制销售数量</span>
          </div>
        </div>
      </div>
      <div class="itemBtnS">
        <!-- <el-button class="btnL" @click="nopower">取消授权</el-button> -->
        <el-button class="btnL" @click="power">确认授权</el-button>
      </div>
    </el-dialog>
    <addProDialog v-if="addProvisible" ref="addProDialog" :typeArr="typeArr" @addProClose="ProClose"></addProDialog>
  </div>
</template>
<script>
import {LongActingTicketList,ScenicProductType,GetTermBill,ScenicAuthorizationDis , ScenicCancelDisImpower} from '@/request/scenic.js'
import { MessageBox ,Message} from 'element-ui';
import addProDialog from "./addProDialog.vue";
export default {
  props:['AuthorizableId'],
  components:{
    addProDialog
  },
  data() {
    return {
      typeArr:[],
      addProvisible:false,
      dataAuthorDialogVisible: false, // 期票授权
      options: [
      ],
      Useoptions:[
        {
          label:'上线',
          value:'0'
        },
        {
          label:'下线',
          value:'1'
        }
      ],  
      labelPosition: "top",
      UseFlag:'0',
      ProductName:'',
      ProductType:'',
      form: {
        token:window.sessionStorage.getItem('Token'),
        distrbutorid:'',
        ProductID:'',
        AgentPrice:'',
        DayNumber:'',
        AllNumber:''
      },
      notEmpow:[], // 可授权产品
      empower:[], // 已授权
      rules:{
        AgentPrice:[  { required: true, message: '请输入代理价', trigger: 'blur' }],
        DayNumber:[  { required: true, message: '请输入每天限制购买数量', trigger: 'blur' }],
        AllNumber:[  { required: true, message: '请输入总限制数量', trigger: 'blur' }]
      },
      flow:false,
      arrs:[],
      arrindex:'',
      ProductNamemper:'',
      loadings:true
    };
  },
  created(){
    let data = {
      token:window.sessionStorage.getItem('Token'),
    }
    ScenicProductType(data).then(res=>{
        if(res.data.rcode==200){
          this.options = res.data.result
          this.typeArr=res.data.result
        }
    })
    this.getAuthorizable()
    this.setAuthor()
  },
  methods: {
    handleAgentPriceInput(val) {
      if (val === '' || val === null || val === undefined) {
        this.form.AgentPrice = '';
        return;
      }
      if (/^\d*\.?\d*$/.test(val)) {
        this.form.AgentPrice = val;
      }
    },
    handleDayNumberInput(val) {
      if (val === '' || val === null || val === undefined) {
        this.form.DayNumber = '';
        return;
      }
      if (/^\d*\.?\d*$/.test(val)) {
        this.form.DayNumber = val;
      }
    },
    handleAllNumberInput(val) {
      if (val === '' || val === null || val === undefined) {
        this.form.AllNumber = '';
        return;
      }
      if (/^\d*\.?\d*$/.test(val)) {
        this.form.AllNumber = val;
      }
    },
    chaxunempower(){
      this.loadings = true
      // this.setAuthor()
      let data1 = {
        token:window.sessionStorage.getItem('Token'),
        disid: this.AuthorizableId,
        name:'',
        ProductID:''
      }   
      if (!isNaN(this.ProductNamemper)) {
        data1.ProductID = this.ProductNamemper
      } else {
        data1.name = this.ProductNamemper
      }
      GetTermBill(data1).then(res=>{
        if(res.data.status=='ok'){
          this.empower = res.data.result
          this.empower.map(item=>{
            item.checked = false
            item.NumBerflag = item.DayNumber 
            item.Number  = item.AllNumber
          })
          this.loadings = false
        }else{
          this.empower = []
          this.loadings = false
        }
      })
    },
    ChangeforceUpdate(e){
      this.$forceUpdate()
    },
    nopower(){
    },
    ProClose(){
      this.addProvisible = false
    },
    addProFn(row){
      this.addProvisible = true;
      this.$nextTick(() => {
        this.$refs.addProDialog.addProFn(row);
      });
    },
    chaxun(){
      // this.getAuthorizable()
      let data = {
        token:window.sessionStorage.getItem('Token'),
        type:'0',
        UseFlag:'0',
        // name:this.ProductName,
        ProductType:this.ProductType,
        disid: this.AuthorizableId
      }
      if (!isNaN(this.ProductName)) {
        data.ProductID = this.ProductName
      } else {
        data.name = this.ProductName
      }
      LongActingTicketList(data).then(res=>{
        if(res.data.rcode==200){
          this.notEmpow = res.data.result
        }else{
          this.notEmpow = []
        }
      })
    },  
    select1(){
      if(this.form.AgentPrice!=''){
          if(this.form.AgentPrice<=0){
            Message.error('代理价不能小于0')
            return false
          }
      }
      this.notEmpow.map(item=>{
          item.checked = true
      })
      this.notEmpow.map((item,index)=>{
        if(item.checked){
          // item.DayNumber = item.NumBerflag
          // item.AllNumber = item.Number
          item.AgentPrice = this.form.AgentPrice!=''?this.form.AgentPrice:item.AgentPrice
          item.DayNumber = this.form.DayNumber!=''?this.form.DayNumber:item.NumBerflag
          item.AllNumber = this.form.AllNumber!=''?this.form.AllNumber:item.Number
          this.empower.push(item)
        }
      })
      for(let i=this.notEmpow.length-1;i>=0;i--){
          if(this.notEmpow[i].checked){
          this.notEmpow.splice(i, 1);
        }
      }
      this.arrindex = 1
    },
    //选择
    select(form,type){
        if(this.form.AgentPrice!=''){
          if(this.form.AgentPrice<=0){
            Message.error('代理价不能小余0')
            return false
          }
        }
        let arr = []
          this.notEmpow.map((item,index)=>{
            if(item.checked){
              item.AgentPrice = this.form.AgentPrice!=''?this.form.AgentPrice:item.AgentPrice
              item.DayNumber = this.form.DayNumber!=''?this.form.DayNumber:item.NumBerflag
              item.AllNumber = this.form.AllNumber!=''?this.form.AllNumber:item.Number
              item.checked = true
              this.empower.push(item)
              arr.push(item)
            }
          })
          for(let i=this.notEmpow.length-1;i>=0;i--){
              if(this.notEmpow[i].checked){
                this.notEmpow.splice(i, 1);
              }
          }
          this.empower.map(item=>{
            item.checked = false
          })
          this.notEmpow.map(item=>{
            item.checked = false
          })
          this.form.AgentPrice = ''
          this.form.DayNumber = ''
          this.form.AllNumber = ''
      // }
      this.arrindex = 1
      this.$forceUpdate()
    },
    // 取消
    cancel(type){
      if(type=='1'){
        this.empower.map(item=>{
          item.checked = true
        })
      }
      this.empower.map(item=>{
        if(item.checked){
          this.notEmpow.push(item)
          this.arrs.push(item)
        }
      })
      for(let i=this.empower.length-1;i>=0;i--){
          if(this.empower[i].checked){
            this.empower.splice(i, 1);
          }
      }
      this.notEmpow.map(item=>{
        item.checked = false
      })
      this.arrindex = 2
      this.$forceUpdate()
    },
    // 确认授权
    power(){
      if(this.arrindex=='1'){
        let form = {
          token:window.sessionStorage.getItem('Token'),
          AgentPrice:'',
          distrbutorid:this.AuthorizableId,
          DayNumber:'',
          AllNumber:'',
          ProductID:''
        }
        this.empower.map(item=>{
          form.ProductID += item.ProductID + ','
          form.AgentPrice += item.AgentPrice + ','
          form.DayNumber += item.DayNumber + ','
          form.AllNumber += item.AllNumber + ','
        })
        if (form.ProductID.length > 0) {
          form.ProductID  = form.ProductID.substr(0,form.ProductID.length - 1);
        }
        if (form.AgentPrice.length > 0) {
          form.AgentPrice = form.AgentPrice.substr(0,form.AgentPrice.length - 1);
        }
        if (form.DayNumber.length > 0) {
          form.DayNumber = form.DayNumber.substr(0, form.DayNumber.length - 1);
        }
        if (form.AllNumber.length > 0) {
            form.AllNumber = form.AllNumber.substr(0, form.AllNumber.length - 1);
        }
        ScenicAuthorizationDis(form).then(res=>{
          if(res.data.status=='ok'){
            Message.success(res.data.msg)
            this.loadings = true
            this.empower = []
            this.setAuthor()
            this.arrindex = ''
          }else{
            Message.error(res.data.msg)
          }
        })
      }else if(this.arrindex=='2'){
        let form = {
          token:window.sessionStorage.getItem('Token'),
          DistributorID:this.AuthorizableId,
          ProductID:''
        }
        this.arrs.map(item=>{
          form.ProductID += item.ProductID + ','
        })
        if (form.ProductID.length > 0) {
          form.ProductID  = form.ProductID.substr(0,form.ProductID.length - 1);
        }
        ScenicCancelDisImpower(form).then(res=>{
          if(res.data.status=='ok'){
            Message.success('取消授权成功')
            this.loadings = true
            this.empower = []
            this.setAuthor()
            this.arrindex = ''
          }else{
            Message.error(res.data.msg)
          }
        })
      }
     
    },
    // 可授权列表
    getAuthorizable(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        type:'0',
        UseFlag:'0',
        name:this.ProductName,
        ProductType:this.ProductType,
        disid: this.AuthorizableId
      }
      LongActingTicketList(data).then(res=>{
        if(res.data.rcode==200){
          this.notEmpow = res.data.result
        }else{
          this.notEmpow = []
        }
      })
    
    },  
    // 已授权
    setAuthor(){
      let data1 = {
        token:window.sessionStorage.getItem('Token'),
        disid: this.AuthorizableId,
        name:'',
        ProductID:''
      }
      // ProductNamemper
      GetTermBill(data1).then(res=>{
        if(res.data.status=='ok'){
          this.empower = res.data.result
          this.empower.map(item=>{
            item.checked = false
            item.NumBerflag = item.DayNumber 
            item.Number  = item.AllNumber
          })
          this.loadings = false
        }else{
          this.empower = [ ]
          this.loadings = false
        }
      })
    },
    // 期票授权
    dataAuthor() {
      this.dataAuthorDialogVisible = true;
    },
    // 期票授权X
    dataAuthorHandleClose() {
      this.dataAuthorDialogVisible = false;
      this.$emit('AuthoClose')
    }
  }
};
</script>

<style lang='less' scoped>
.itemBtnS {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 20px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.contentQp {
  width: 100%;
  height: 490px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .qpLeft {
    width: 40%;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
  }
  .qpCenter {
    width: 15%;
    height: 490px;
    background: #ffffff;
    border-radius: 4px;

    .qpCenterBtn {
      >span{
        color: red;
        display: block;
        text-align: center;
        font-size: 16px;
      }
      > div:nth-child(2) {
        width: 100%;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        button {
          width:  100%;
          height: 40px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #246deb;
          cursor: pointer;
          margin-bottom: 20px;
        }
      }
      > div:nth-child(3) {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        button {
          width:  100%;
          height: 40px;
          background: #ffffff;
          border: 1px solid #e74c3c;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #e74c3c;
          margin-bottom: 20px;
          cursor: pointer;
        }
      }
    }
    /deep/.el-form-item {
      margin-bottom: 1rem;
    }
    /deep/.el-form-item__label {
      text-align: right;
      vertical-align: middle;
      float: left;
      line-height: 30px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .qpRight {
    width: 40%;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
    > div:nth-child(1) {
      font-style: normal;
      font-weight: 400;
      // color: #e74c3c;
      color: #666666;
      font-size: 1.4rem;
      span {
        margin-right: 10px;
      }
    }
    >div:last-child{
      color: red;
    }
  }
}
.titleSear {
  display: flex;
  .sel {
    margin-right: 20px;
  }
  .el-select {
    width: 260px;
  }
  .el-input {
    width: 300px;
    margin: 0 20px 0 0;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.empow{
  color: #666666;
  font-size: 1.4rem;
  margin:1.2rem 2.1rem  1.8rem 0;
  cursor: pointer;
}
/deep/ .el-dialog{
  min-width: 700px !important;
}
/deep/ .is-checked .el-checkbox__inner{
  background: #4ECB73 !important;
  border-color: #4ECB73 !important;
}
</style>